import { AdapterConfiguration, RestAdapter } from 'rest-adapter';
import { Config } from '../Config';
import { ServiceLocator } from '../ServiceLocator';

export class RestAdapterFactory {
    constructor(private readonly serviceLocator: ServiceLocator, private readonly config: Config) {
    }

    public get(): RestAdapter {
        const adapterConfiguration = this.buildAdapterConfiguration();

        return new RestAdapter(adapterConfiguration);
    }

    public buildAdapterConfiguration(): AdapterConfiguration {
        const requestSettings: RequestInit = {
            credentials: 'include',
            // mode: 'no-cors',
            // headers: {'X-Requested-With': 'XMLHttpRequest'}
            headers: {'Accept-Language': this.config.language}
        };
        const adapterConfiguration = AdapterConfiguration.fromUrl(
            `${process.env.REACT_APP_API_URL}`,
            requestSettings
        );
        adapterConfiguration.fetchCallback = (input: RequestInfo, init?: RequestInit): Promise<Response> => {
            return fetch(input, init);
        };
        return adapterConfiguration;
    }
}
